<template>
    <div class="spaced-container">
        <!-- Page Content Wrapper -->
        <div id="page-content-wrapper" class="admin-content-area">
            <template>
                <div class="container-fluid xyz">
                    <div class="page-header-top-container">
                        <div class="page-name">{{pageTitle}}</div>
                        <!--<button type="submit" v-on:click="buttonBack()" class="btn btn-primary waves-effect pull-right">Back</button>-->
                    </div>
                    <!--page content-->
                    <div class="admin-page-content">
                        <!--Forms-->
                        <div class="forms-container add_user_forms_container vtc-dealer-forms">
                            <div class="row no-margin">
                                <ul class="nav nav-tabs">
                                    <li class="nav-item">
                                        <a v-if="$store.state.roleName == 'Participant'" v-on:click="activetab=1" v-bind:class="'nav-link ' + [ activetab === 1 ? 'active' : '' ]">Attendant Class</a>
                                    </li>
                                    <li class="nav-item">
                                        <a v-on:click="activetab=2" v-bind:class="'nav-link ' + [ activetab === 2 ? 'active' : '' ]">Upcoming Class</a>
                                    </li>
                                </ul>

                                <div v-if="activetab === 1" class="tabcontent" id="customer-activity-logs1" >
                                    <attandent-class></attandent-class>
                                </div>
                                <div v-if="activetab === 2" class="tabcontent" id="customer-activity-logs2" >
                                    <upcoming-class></upcoming-class>
                                </div>

                            </div>
                        </div>
                        <!-- Forms -->
                    </div>
                    <!--page content-->
                </div>
            </template>
        </div>
        <!-- Page Content Wrapper -->
    </div>
</template>

<script>
    var self;
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import {commonMixins} from '../../../mixins/commonMixins';
    import EventBus from "../.././event-bus";
    import {HTTP} from '../../../http-common';

    import AttandentClass from "@/components/Class/TabView/ListAttandentClass";
    import UpcomingClass from "@/components/Class/TabView/ListUpcomingClass";

    export default {
        name: 'ListClass',
        components: {
            "attandent-class": AttandentClass,
            "upcoming-class": UpcomingClass,
        },

        mixins: [commonMixins],
        data() {
            return {
                activetab: 1,
                pageTitle: "Class List",
            }
        },
        beforeMount() {
            self = this;
            if (self.$store.state.roleName == 'Admin') {
                self.activetab = 2;
            } else {
                self.activetab = 1;
            }
        },
        mounted: function () {
            self.staticInputLabelMessages = self.allLabelMessages;
            self.staticMessages = self.allStaticMessages;
            self.setActiveMenu('listclassinfo');
            EventBus.$emit("menu-selection-changed", "listclassinfo");

        },

        methods: {
            buttonBack() {
            },
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/Class/TabView/TabView.vue